export default __webpack_public_path__ + "static/media/mobile-mountain-header.fdbf22e7.png";